<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';

  import type { SectionTitleStoryblok } from '$types/bloks';
  import Button from './ui/button.svelte';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';

  export let as: 'h1' | 'h2' | 'h3' = 'h2';
  export let block: SectionTitleStoryblok;

  let className: string | undefined = undefined;
  export { className as class };
</script>

<div
  use:storyblokEditable={block}
  class={cn(
    'mb-4 w-fit max-w-lg px-2 lg:px-0',
    block.variant === 'center' && 'mx-auto mb-11 text-center lg:mb-14',
    className
  )}
>
  <svelte:element
    this={as}
    class={cn(
      'relative text-4xl font-semibold',
      block.variant === 'center' && 'max-w-[480px] text-8xl'
    )}
  >
    {block.title}
  </svelte:element>

  {#if block.subtitle && block.variant === 'center'}
    <p class="mt-2 text-2xl">{block.subtitle}</p>
  {/if}

  {#if block.button && block.button.length > 0 && block.button[0].url?.id}
    {@const { href, rel, target } = $getAnchorFromCmsLink(block.button[0].url)}
    <Button name={block.button[0].text} class="mt-6" variant="accent" as="a" {href} {rel} {target}
      >{block.button[0].text}</Button
    >
  {/if}
</div>
